import { extendTheme } from "@chakra-ui/react";
import { buttonStyles } from "./components/button";

export default extendTheme(
    buttonStyles,
    // { breakpoints, fonts, fontSizes }, // Breakpoints
  
    // globalStyles
  );
  